import React, { useState } from "react";
import { ReactComponent as AddCamera } from "assets/img/icons/camera.svg";
import { ReactComponent as DeleteIcon } from "assets/img/icons/Delete.svg";
import ImageSelectAndCrop from "components/ImageSelectAndCrop";
import UserService from "services/UserService";
import { useToasts } from "react-toast-notifications";
import classNames from "classnames";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import ImageDisplay from "components/AttachmentPreview/Display/ImageDisplay";
import { useGlobalContext } from "store/contexts/globalContext";

const styles = {
  updateCover: {
    position: "absolute",
    top: "10px",
    right: "10px",
    boxShadow:
      "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    color: "black",
    width: "24px",
    height: "24px",
  },
  removeCover: {
    position: "absolute",
    top: "10px",
    // boxShadow:
    //   "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    color: "black",
    width: "40px",
    height: "24px",
  },
  uploadingOverlay: {
    height: "calc(100% - 30px)",
    width: "100%",
    position: "absolute",
    zIndex: "101",
    background: "#000a",
    color: "white",
    fontWeight: "400",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  previewDialog: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  previewDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    pointerEvents: "none",
    opacity: "0.7",
  },
  closeIcon: {
    width: "25px",
    cursor: "pointer",
    fill: "white",
  },

  closeContainer: {
    padding: "20px",
    position: "absolute",
    top: 0,
    right: 0,
  },
};

export default ({ children, profile, setProfile, isOwner }) => {
  const classes = styles;
  const { addToast } = useToasts();
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const { microsoftConfigureTab } = useGlobalContext();

  const updateCover = async (file) => {
    setIsUpdating(true);

    try {
      await UserService.updateUserCover(file);

      addToast("User profile cover updated successfully ", {
        appearance: "success",
      });
    } catch (error) {}

    setIsUpdating(false);
    setProfile({
      ...profile,
      profile: {
        ...profile.profile,
        cover: file !== null ? URL.createObjectURL(file) : null,
      },
    });
  };

  const showAvatar = (event) => {
    if (profile.profile.cover) {
      if (!microsoftConfigureTab) {
        document.getElementById("footer").style.zIndex = "-1";
      }
      document.getElementById("header").style.zIndex = "-1";
      setShowPreviewDialog(true);
      return;
    }
    return;
  };

  const preventDefaultOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  const closePreviewDailog = () => {
    if (!microsoftConfigureTab) {
      document.getElementById("footer").style.zIndex = "1";
    }
    document.getElementById("header").style.zIndex = "1";
    setShowPreviewDialog(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        className={classNames({
          profileHeaderContainer: true,
          cursor: profile.profile.cover && true,
          notClickAble: !profile.profile.cover && true,
        })}
        onClick={showAvatar}
        id="cover"
        style={{
          backgroundImage: `url(${profile.profile.cover})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 250px",
        }}
      >
        {isUpdating && (
          <div style={classes.uploadingOverlay}>
            <span>Uploading...</span>
          </div>
        )}
        {children}
      </div>
      {isOwner && (
        <>
          <ImageSelectAndCrop
            id="cover-image-file"
            aspect={16 / 4}
            onUpdate={updateCover}
          >
            <AddCamera style={classes.updateCover}></AddCamera>
          </ImageSelectAndCrop>
        </>
      )}
      {profile.profile.cover && (
        <DeleteIcon
          onClick={() => updateCover(null)}
          style={classes.removeCover}
        ></DeleteIcon>
      )}
      {showPreviewDialog && (
        <div style={classes.previewDialog} onClick={closePreviewDailog}>
          <div style={classes.previewDialogBackdrop}></div>
          <div style={classes.closeContainer}>
            <CloseIcon style={classes.closeIcon} onClick={closePreviewDailog} />
          </div>
          <div
            className="imagePreviewContentContainer"
            onClick={preventDefaultOnClick}
          >
            <ImageDisplay attachmentSrc={profile.profile.cover} />
          </div>
        </div>
      )}
    </div>
  );
};
